import React, { useState } from 'react';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faClose } from "@fortawesome/free-solid-svg-icons";
import axios from "axios";
import { toastify } from '../components/Toast';
import 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

function CreateBucket({ setPopup, parent, cardUpdate, bucketUpdate, bucketOperation, bucketNameText, changeTxt, bucketUpdateId, isReminderEmail }) {
  // Default state is set to true (on)
  const [enabled, setEnabled] = useState(bucketOperation === 'Update' ? isReminderEmail : true);
  const createBucket = async (name) => {
    const userData = JSON.parse(localStorage.getItem('userData'));
    const token = localStorage.getItem('token');
    try {
      const response = await axios.post(`${process.env.REACT_APP_API}buckets/add`, { name, userId: userData._id, parentId: parent, isReminderEmail: enabled },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          }
        }
      );
      if (bucketOperation === 'subbucket') {
        cardUpdate()
      }
      toastify("success", response.data.message);
    } catch (error) {
      console.error(error);
      toastify("error", error.response.data.message);
    }
  };

  const updateCreateBucket = async (id, name) => {
    JSON.parse(localStorage.getItem('userData'));
    const token = localStorage.getItem('token');
    if (name === '') {
      toastify("error", "Enter a bucket name to save this bucket");
      return;
    }
    try {
      const response = await axios.patch(`${process.env.REACT_APP_API}buckets/update`, { bucketId: id, name: name, isReminderEmail: enabled },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          }
        }
      );
      toastify("success", response.data.message);
    } catch (error) {
      console.error(error);
      toastify("error", error.response.data.message);
    }
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    const name = event.target.name.value.trim(); // Get the name value from the form
    if (bucketOperation === 'Add') {
      await createBucket(name);
    } else if (bucketOperation === 'subbucket') {
      await createBucket(name);
    } else {
      await updateCreateBucket(bucketUpdateId, name);
    }

    setPopup(false);
    bucketUpdate();
  };

  function closePopup() {
    setPopup(false);
  }

  return (
    <div className="bucketCreationPopuptags relative !z-[999]" onClick={closePopup}>
      <form className="addBucket relative w-[85%] md:w-[500px]" onSubmit={handleSubmit} onClick={(e) => e.stopPropagation()}>
        <span onClick={closePopup} className="absolute right-0 top-0 w-6 h-6 bg-[#000] m-4 flex justify-center items-center rounded-full">
          <FontAwesomeIcon className="cursor-pointer text-white text-[14px]" icon={faClose} />
        </span>
        <h2 style={{ textAlign: "left" }}>{
          (bucketOperation === "Update") ? "Edit" : (bucketOperation === "subbucket") ? "Create New Sub" : (bucketOperation === "Update Sub") ? "Edit Sub" : "Create New"
        } Bucket</h2>
        <input className="p-3 border border-1 rounded-lg mt-4 inputspaces-content" type="text" name="name" placeholder="Enter Bucket Name" onChange={changeTxt} value={bucketNameText} />
        <div className="flex items-center space-x-3">
          <span className="text-sm font-medium text-gray-700">Include in reminders</span>
          <button
            onClick={() => setEnabled(!enabled)}
            className={`relative w-14 h-7 rounded-full transition-colors duration-300 ease-in-out outline-none ${enabled ? 'bg-orange-500' : 'bg-gray-300'
              }`}
            type="button"
            role="switch"
            aria-checked={enabled}
          >
            <span className="sr-only">{enabled ? 'Enabled' : 'Disabled'}</span>
            <span
              className={`absolute top-1 left-1 bg-white w-5 h-5 rounded-full shadow transform transition-transform duration-300 ease-in-out ${enabled ? 'translate-x-7' : 'translate-x-0'
                }`}
            />
          </button>
          <span className="text-sm font-medium text-gray-900">
            {enabled ? 'ON' : 'OFF'}
          </span>
        </div>
        <div className="flex justify-end">
          <button style={{ filter: 'drop-shadow(0px 10px 20px rgba(0, 0, 0, 0.161))' }} className="buttonpadding-content text-[16px] rounded-full bg-[#FF6600] text-white">
            <span className="savebutton-context">{bucketOperation === 'Add' || bucketOperation === 'subbucket' ? 'Create' : 'Update'}</span>
          </button>
        </div>
        {/* <button className="savebutton-context" type="submit">{(bucketOperation == "subbucket")? "Add": (bucketOperation == "Update Sub")? "Update":bucketOperation}</button> */}
        {/* <button style={{ filter: 'drop-shadow(0px 10px 20px rgba(0, 0, 0, 0.161))' }} className="buttonpadding-content text-[16px] rounded-full bg-[#FF6600] text-white">
                  <span className="savebutton-context">Create</span>
                </button> */}
      </form>
    </div>
  )
}

export default CreateBucket;